import { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
export const jobsData = [
  // {
  //   id: 0,
  //   tabTitle: "main1.karrier.felszolgalo.tabTitle",
  //   path: "felszolgalo",

  //   title: "main1.karrier.felszolgalo.title",
  //   subtext: "main1.karrier.felszolgalo.subtext",
  // place: "1052 Budapest, Jane Haining rkp. 10, Dock 10",

  //   contract: "main1.karrier.felszolgalo.contract",
  //   start: "main1.karrier.felszolgalo.start",
  //   tasks: [
  //     "main1.karrier.felszolgalo.tasks.1",
  //     "main1.karrier.felszolgalo.tasks.2",
  //     "main1.karrier.felszolgalo.tasks.3",
  //     "main1.karrier.felszolgalo.tasks.4",
  //   ],
  //   expectations: [
  //     "main1.karrier.felszolgalo.expectations.1",
  //     "main1.karrier.felszolgalo.expectations.2",
  //     "main1.karrier.felszolgalo.expectations.3",
  //     "main1.karrier.felszolgalo.expectations.4",
  //     "main1.karrier.felszolgalo.expectations.5",
  //   ],
  //   benefits: [
  //     "main1.karrier.felszolgalo.benefits.1",
  //     "main1.karrier.felszolgalo.benefits.2",
  //     "main1.karrier.felszolgalo.benefits.3",
  //     "main1.karrier.felszolgalo.benefits.4",
  //     "main1.karrier.felszolgalo.benefits.5",
  //   ],
  //   experience: "main1.karrier.experienceV",
  //   mailto: "torocsik.rita@dunacruises.com",
  // },
  // {
  //   id: 1,
  //   tabTitle: "main1.karrier.jegyertekesito.tabTitle",
  //   path: "jegyertekesito",
  //   title: "main1.karrier.jegyertekesito.title",
  //   subtext: "main1.karrier.jegyertekesito.subtext",
  //   place: "1052 Budapest, Március 15. tér Dock 10.",
  //   contract: "main1.karrier.jegyertekesito.contract",
  //   start: "main1.karrier.jegyertekesito.start",
  //   tasks: [
  //     "main1.karrier.jegyertekesito.tasks.1",
  //     "main1.karrier.jegyertekesito.tasks.2",
  //     "main1.karrier.jegyertekesito.tasks.3",
  //   ],
  //   expectations: [
  //     "main1.karrier.jegyertekesito.expectations.1",
  //     "main1.karrier.jegyertekesito.expectations.2",
  //     "main1.karrier.jegyertekesito.expectations.3",
  //   ],
  //   benefits: [
  //     "main1.karrier.jegyertekesito.benefits.1",
  //     "main1.karrier.jegyertekesito.benefits.2",
  //     "main1.karrier.jegyertekesito.benefits.3",
  //     "main1.karrier.jegyertekesito.benefits.4",
  //   ],
  //   mailto: "parrag.bettina@dunacruises.com",
  // },
  {
    id: 2,
    tabTitle: "main1.karrier.hajovezeto.tabTitle",
    path: "hajovezeto",
    title: "main1.karrier.hajovezeto.title",
    subtext: "main1.karrier.hajovezeto.subtext",
    place: "1052 Budapest, Jane Haining rkp. 10, Dock 10",
    contract: "main1.karrier.hajovezeto.contract",
    start: "main1.karrier.hajovezeto.start",
    tasks: ["main1.karrier.hajovezeto.tasks.1", "main1.karrier.hajovezeto.tasks.2"],
    expectations: [
      "main1.karrier.hajovezeto.expectations.1",
      "main1.karrier.hajovezeto.expectations.2",
      "main1.karrier.hajovezeto.expectations.3",
    ],
    benefits: [
      "main1.karrier.hajovezeto.benefits.1",
      "main1.karrier.hajovezeto.benefits.2",
      "main1.karrier.hajovezeto.benefits.3",
      "main1.karrier.hajovezeto.benefits.4",
      "main1.karrier.hajovezeto.benefits.5",
    ],
    mailto: "istvan.biro@dunacruises.com",
  },
  // {
  //   id: 3,
  //   tabTitle: "main1.karrier.matroz.tabTitle",
  //   path: "matroz",
  //   title: "main1.karrier.matroz.title",
  //   subtext: "main1.karrier.matroz.subtext",
  //   place: "1052 Budapest, Jane Haining rkp. 10, Dock 10",
  //   contract: "main1.karrier.matroz.contract",
  //   start: "main1.karrier.matroz.start",
  //   tasks: ["main1.karrier.matroz.tasks.1", "main1.karrier.matroz.tasks.2"],
  //   expectations: ["main1.karrier.matroz.expectations.1", "main1.karrier.matroz.expectations.2"],
  //   benefits: [
  //     "main1.karrier.matroz.benefits.1",
  //     "main1.karrier.matroz.benefits.2",
  //     "main1.karrier.matroz.benefits.3",
  //     "main1.karrier.matroz.benefits.4",
  //     "main1.karrier.matroz.benefits.5",
  //   ],
  //   experience: "main1.karrier.matroz.experience",

  //   mailto: "istvan.biro@dunacruises.com",
  // },
  // {
  //   id: 4,
  //   tabTitle: "main1.karrier.sales.tabTitle",
  //   path: "sales",
  //   title: "main1.karrier.sales.title",
  //   subtext: "main1.karrier.sales.subtext",
  //   place: "1052 Budapest, Jane Haining rkp. 10, Dock 10",
  //   contract: "main1.karrier.sales.contract",
  //   start: "main1.karrier.sales.start",
  //   tasks: [
  //     "main1.karrier.sales.tasks.1",
  //     "main1.karrier.sales.tasks.2",
  //     "main1.karrier.sales.tasks.3",
  //     "main1.karrier.sales.tasks.4",
  //   ],
  //   expectations: [
  //     "main1.karrier.sales.expectations.1",
  //     "main1.karrier.sales.expectations.2",
  //     "main1.karrier.sales.expectations.3",
  //     "main1.karrier.sales.expectations.4",
  //     "main1.karrier.sales.expectations.5",
  //     "main1.karrier.sales.expectations.6",
  //     "main1.karrier.sales.expectations.7",
  //     "main1.karrier.sales.expectations.8",
  //   ],
  //   benefits: [
  //     "main1.karrier.sales.benefits.1",
  //     "main1.karrier.sales.benefits.2",
  //     "main1.karrier.sales.benefits.3",
  //     "main1.karrier.sales.benefits.4",
  //     "main1.karrier.sales.benefits.5",
  //     "main1.karrier.sales.benefits.6",
  //   ],
  //   experience: "main1.karrier.sales.experience",

  //   mailto: "sales@dunacruises.com",
  // },
  // {
  //   id: 5,
  //   tabTitle: "main1.karrier.karbantarto.tabTitle",
  //   path: "karbantarto",
  //   title: "main1.karrier.karbantarto.title",
  //   subtext: "main1.karrier.karbantarto.subtext",
  //   place: "Dock 10 - 1052, Budapest, Jane Haining rkp 10./" + "\n" + "1044, Budapest, Rév utca 4.",
  //   contract: "main1.karrier.karbantarto.contract",
  //   start: "main1.karrier.karbantarto.start",
  //   tasks: [
  //     "main1.karrier.karbantarto.tasks.1",
  //     "main1.karrier.karbantarto.tasks.2",
  //     "main1.karrier.karbantarto.tasks.3",
  //     "main1.karrier.karbantarto.tasks.4",
  //     "main1.karrier.karbantarto.tasks.5",
  //   ],
  //   expectations: [],
  //   benefits: [
  //     "main1.karrier.karbantarto.benefits.1",
  //     "main1.karrier.karbantarto.benefits.2",
  //     "main1.karrier.karbantarto.benefits.3",
  //     "main1.karrier.karbantarto.benefits.4",
  //     "main1.karrier.karbantarto.benefits.5",
  //     "main1.karrier.karbantarto.benefits.6",
  //     "main1.karrier.karbantarto.benefits.7",
  //   ],
  //   // experience: "main1.karrier.experience",

  //   mailto: "istvan.biro@dunacruises.com",
  // },
  // {
  //   id: 6,
  //   tabTitle: "main1.karrier.asztalos.tabTitle",
  //   path: "asztalos",
  //   title: "main1.karrier.asztalos.title",
  //   subtext: "main1.karrier.asztalos.subtext",
  //   place: "Dock 10 - 1052, Budapest, Jane Haining rkp 10.",
  //   contract: "main1.karrier.asztalos.contract",
  //   start: "main1.karrier.asztalos.start",
  //   tasks: [
  //     "main1.karrier.asztalos.tasks.1",
  //     "main1.karrier.asztalos.tasks.2",
  //     "main1.karrier.asztalos.tasks.3",
  //   ],
  //   expectations: [],
  //   benefits: [
  //     "main1.karrier.asztalos.benefits.1",
  //     "main1.karrier.asztalos.benefits.2",
  //     "main1.karrier.asztalos.benefits.3",
  //     "main1.karrier.asztalos.benefits.4",
  //     "main1.karrier.asztalos.benefits.5",
  //     "main1.karrier.asztalos.benefits.6",
  //     "main1.karrier.asztalos.benefits.7",
  //   ],
  //   // experience: "main1.karrier.experience",

  //   mailto: "istvan.biro@dunacruises.com",
  // },
];
const Career = ({ t }) => {
  const [tabIndex, setTabIndex] = useState(null);
  const location = useLocation();
  useEffect(() => {
    jobsData.forEach((e, i) => {
      if (location.pathname.includes(e.path)) return setTabIndex(i);
    });
  }, [location]);
  return (
    <div className="career-page-alt">
      <div className="head-wrap">
        <h2>{t("main1.karrier.h")}</h2>
        {window.location.pathname.split("/").filter((e) => e !== "").length < 3 && (
          <p className="select">{t("main1.karrier.p")}</p>
        )}
      </div>

      <div className="main-wrapper">
        <div className="tabs">
          {jobsData.map((e, i) => {
            return (
              <Link key={i} to={e.path} style={{ display: "block" }}>
                <div
                  className={`tab ${tabIndex === i ? "active" : ""}`}
                  onClick={() => setTabIndex(i)}>
                  <p>{t(e.tabTitle)}</p>
                </div>
              </Link>
            );
          })}
        </div>
        <Outlet context={[tabIndex, setTabIndex]}></Outlet>
      </div>
    </div>
  );
};
export default Career;
